module.exports = __webpack_public_path__ + "img/ang4.b4eced24.png";